export default __webpack_public_path__ + "static/media/bean-product.6f768592.webp";